export function SellerShopProductSkeleton() {
  return (
    <div className="overflow-hidden rounded-xl bg-white shadow-sm">
      <div className="flex flex-col md:flex-row">
        <div className="flex flex-1 items-center gap-2 p-2">
          <div className="h-14 w-14 shrink-0 animate-pulse rounded-lg bg-[#F0E0C7]/60" />
          <div className="flex-1 space-y-1">
            <div className="h-3 w-3/4 animate-pulse rounded bg-[#F0E0C7]/60" />
            <div className="h-2.5 w-1/2 animate-pulse rounded bg-[#F0E0C7]/60" />
            <div className="h-3 w-28 animate-pulse rounded bg-[#F0E0C7]/60" />
          </div>
        </div>
        <div className="flex items-center justify-between gap-1.5 border-t border-gray-100 p-1.5 md:flex-col md:border-t-0 md:border-l">
          <div className="flex gap-1">
            <div className="h-6 w-6 animate-pulse rounded bg-[#F0E0C7]/60" />
            <div className="h-6 w-6 animate-pulse rounded bg-[#F0E0C7]/60" />
          </div>
          <div className="h-6 w-11 animate-pulse rounded-full bg-[#F0E0C7]/60" />
        </div>
      </div>
    </div>
  );
}

export default function SellerShopSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 gap-2 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
      {Array.from({ length: count }).map((_, index) => (
        <SellerShopProductSkeleton key={`seller-product-${index}`} />
      ))}
    </div>
  );
}
